import React from "react";
import { observer } from "mobx-react";
import { FacilityOrderNewFlowUSIntakeSinglePagePreviewTemplate } from "themes/application/facility-order-new-flow-us-intake-single-page/pages";
import { FacilityOrderNewFlowUSIntakeSinglePagePreviewViewStore } from "application/facility-order-new-flow-us-intake-single-page/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderNewFlowUSIntakeSinglePagePreviewViewStore(rootStore), "facilityOrderNewFlowUSIntakeSinglePagePreviewViewStore")
@observer
class FacilityOrderNewFlowUSIntakeSinglePagePreview extends React.Component {
	render() {
		return <FacilityOrderNewFlowUSIntakeSinglePagePreviewTemplate {...this.props} />;
	}
}

export default FacilityOrderNewFlowUSIntakeSinglePagePreview;